import script from "./help.vue?vue&type=script&setup=true&lang=js"
export * from "./help.vue?vue&type=script&setup=true&lang=js"

import "./help.vue?vue&type=style&index=0&id=7a8e2a8b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8e2a8b"]])

export default __exports__